<template>
  <transition name="fade">
    <div class="modal-wrapper" v-show="isOpen" @click="clickOnBg">
      <div class="modal-container" @click.stop>
        <slot @close="toggle"></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data: () => {
    return {
      open: false
    }
  },
  props: ['modalOpen'],
  computed: {
    isOpen() {
      return this.open
    }
  },
  mounted() {},
  methods: {
    toggle() {
      this.open = !this.open
    },
    clickOnBg() {
      this.$emit("modalClickOnBackground")
    }
  },
  watch: {
    'modalOpen': function () {
      this.open = this.modalOpen
      //this.toggle()
    }
  },
  components: {},

};
</script>

<style lang="scss">
.modal-wrapper {
  position: fixed;
  z-index: 9999;

  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;

  background-color: rgba($color: #000000, $alpha: 0.6);
  backdrop-filter: blur(2px);

  &.strong-blur {
    backdrop-filter: blur(5px);
  }

  display: flex;
  justify-content: center;
  align-items: center;

  &.hidden {
    visibility: hidden;
    opacity: 0;
  } 
  &.open {
    visibility: visible;
    opacity: 1;
  }

  .modal-container {
    border: 1px solid #E4E4E4;
    border-radius: 2px;
    background-color: #252525;

    width: 40%;
    min-width: 420px;
    min-height: 210px;
    
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .title {
      font-size: 18px;
      color: rgba($color: #ffffff, $alpha: 0.85);
      font-weight: 700;
      margin-bottom: 12px;
      text-transform: capitalize;
    }
    .text {
      font-size: 16px;
      color: rgba($color: #ffffff, $alpha: 0.85);
      font-weight: 400;

    }
    .highlight {
      color: rgba($color: #FFB300, $alpha: 0.85);
      font-weight: 500;
    }
    .actions {
      margin-top: 12px;
      span {
        margin: 0 4px;
      }
    }
    .input {
      width: 100%;
      text-align: center;
    }

    .error {
      margin-top: 6px;
      font-size: 12px;
      color: rgba($color: #ff0707, $alpha: 0.8);
      text-align: center;
    }
  }
}
</style>